<template>
  <component :is="tag" class="vue__form-header">
    <slot></slot>
  </component>
</template>

<script>
  export default {
    props: {
      tag: {
        type: String,
        default: 'h2',
        validator: value => ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(value),
      },
    }, 
  };
</script>

<style lang="scss" scoped>
  h1,h2,h3,h4,h5,h6{font-weight:700;margin-bottom:10px}

  h2{font-size:32px;line-height:36px;margin-top:20px}

  h3{font-size:24px;line-height:30px;margin-top:20px}

  h4{font-size:18px;line-height:24px;margin-top:10px}

  h5{font-size:14px;line-height:20px;margin-top:10px}

  h6{font-size:12px;line-height:18px;margin-top:10px}

  .vue__form-header {
    margin-top: 0;
    text-align: center;
    font-weight: 400;
    margin-bottom: 2rem;
  }
</style>
